import { FormattedMessage } from "react-intl";

import {
  ExchangeType,
  IAssetComponentHistory,
  IContract,
  IExchangePurchaseRaffleEvent,
  TContractEventData,
} from "@framework/types";
import { Typography } from "@dzambalaorg/ui-kit";

import { AssetsView } from "../../../../../components/common/event-history-assets-view";
import {
  StyledDataViewAddressLinkWrapper,
  StyledDataViewItemContentWrapper,
  StyledDataViewItemWrapper,
  StyledDataViewWrapper,
} from "../styled";

export interface IPurchaseRaffleDataViewProps {
  assets: Array<IAssetComponentHistory>;
  contract: IContract;
  eventData: TContractEventData;
}

export const PurchaseRaffleDataView = (props: IPurchaseRaffleDataViewProps) => {
  const { assets, contract, eventData } = props;
  const { externalId } = eventData as IExchangePurchaseRaffleEvent;

  return (
    <StyledDataViewWrapper>
      <StyledDataViewItemWrapper>
        <Typography fontWeight={500}>
          <FormattedMessage id="enums.eventDataLabel.externalId" />:
        </Typography>
        <StyledDataViewItemContentWrapper>
          <StyledDataViewAddressLinkWrapper>{externalId}</StyledDataViewAddressLinkWrapper>
        </StyledDataViewItemContentWrapper>
      </StyledDataViewItemWrapper>

      <AssetsView assets={assets} contract={contract} type={ExchangeType.ITEM} />
      <AssetsView assets={assets} contract={contract} type={ExchangeType.PRICE} />
    </StyledDataViewWrapper>
  );
};
